import { combineReducers } from 'redux';
import devices from './devices';
import devicesAvailable from './devices-available';
import deviceAssigned from './device-assigned';
import devicesPaginated from './devices-paginated';
import devicesFilter from './devices-filter';
import devicesLastLocations from './devices-last-locations';
import device from './device';
import deviceDetails from './device-details';
import deviceLogs from './device-log';
import notification from './notification';
import breadcrumbs from './breadcrumb';
import measurements from './measurements';
import metrics from './metrics';
import locations from './locations';
import measurementsPoints from './measurements-points';
import account from './account';
import shipment from './shipment';
import shipments from './shipments';
import shipmentsPaginated from './shipments-paginated';
import shipmentsFilter from './shipments-filter';
import shipmentLogs from './shipment-log';
import copiedShipment from './copied-shipment';
import delivery from './delivery';
import meta from './meta';
import backdrop from './backdrop';
import shipmentForm from './shipment-form';
import deeplinkShipment from './deeplink-shipment';
import errors from './errors';
import {
  projectForm,
  projectsAlerts,
  projectsLogs,
  projectsPackages,
  projectsPaginated,
  projectsFilter,
  projectsProducts,
  projectsUsersDevices,
  projects,
  projectDevicesPopup,
  projectUsersPopup,
  projectCustomFields,
  projectAlertConfirmations,
  projectSelect,
  excursionReport
} from './project';
import { user, users, usersPaginated, usersWithoutProjects, usersFilter, userLog, usersByProject, userSelect, userNotification, userApiKeys } from './user';
import { addressbookContactsPaginated, addressbook, addressbooks, addressbookContact } from './addressbook';
import { applianceForm, applianceDevices, appliances, appliance, appliancesPaginated, applianceFilter } from './warehouse/appliance';
import { warehouse, warehouses, warehousesPaginated, warehouseLog } from './warehouse';
import listFilter from './list-filter';
import authChallenge from './auth/auth-challenge';
import configurableTable from './configurable-table';

export default () =>
  combineReducers({
    devices,
    devicesAvailable,
    deviceAssigned,
    devicesPaginated,
    devicesFilter,
    devicesLastLocations,
    device,
    deviceDetails,
    deviceLogs,
    user,
    users,
    usersPaginated,
    usersWithoutProjects,
    usersFilter,
    userLog,
    usersByProject,
    userSelect,
    userNotification,
    userApiKeys,
    notification,
    breadcrumbs,
    measurements,
    metrics,
    measurementsPoints,
    locations,
    account,
    projects,
    projectsUsersDevices,
    projectDevicesPopup,
    projectUsersPopup,
    projectCustomFields,
    projectAlertConfirmations,
    projectSelect,
    projectForm,
    shipment,
    shipments,
    shipmentsPaginated,
    shipmentsFilter,
    shipmentLogs,
    copiedShipment,
    delivery,
    meta,
    backdrop,
    shipmentForm,
    deeplinkShipment,
    projectsAlerts,
    projectsProducts,
    projectsPackages,
    projectsLogs,
    projectsPaginated,
    projectsFilter,
    errors,
    addressbookContactsPaginated,
    addressbook,
    addressbooks,
    addressbookContact,
    warehouse,
    warehouses,
    warehousesPaginated,
    warehouseLog,
    appliance,
    appliances,
    applianceForm,
    applianceDevices,
    appliancesPaginated,
    applianceFilter,
    listFilter,
    authChallenge,
    configurableTable,
    excursionReport
  });
